import React, { useState, useEffect } from 'react'
import DefaultLayout from './components/layout/layout'
import { GlobalStyle } from './styles/global-style'
import { ThemeProvider } from 'styled-components'
import { theme } from './styles/theme'
import Main from './components/main'
import Embedded from './components/embedded'
// import { Helmet } from 'react-helmet-async'
import { logGAPageView, initGA } from './utils/analytics'

import axios from 'axios'

export default function App() {
  const [data, setData] = useState({ blocks: [], entityMap: {} })

  const fetchData = async () => {
    const response = await axios({
      method: 'get',
      url: 'https://statics.mirrormedia.mg/json/post_birdbating.json',
      headers: {
        'Cache-Control': 'no-cache',
      },
    })
    setData(response?.data._items[0])
  }

  useEffect(() => {
    initGA()
    fetchData()
    logGAPageView()
  }, [])

  return (
    <>
      {/* <Helmet>
        <meta charset="utf-8" />
        <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content={
            data?.og_description ??
            '本刊與「台灣動物社會研究會」合作，費時1年調查全台鳥類籠拍（指將鳥類囚禁於特定空間內拍攝）、誘拍（以食物或聲音引誘鳥類至定點拍攝）場所，發現籠中不僅豢養罕見候鳥、保育鳥類，還依時節安排鳥類育雛、交配畫面，最高1年獲利百萬元，把拍鳥變成一門好生意。'
          }
        />
        <meta
          property="og:image"
          content={
            data?.og_image?.image?.url ??
            'https://www.mirrormedia.com.tw/assets/images/20230206184547-b1ae0bb553c1eaff30d616f558e40843.png'
          }
        />
        <meta
          property="og:title"
          content={
            data?.og_title ?? '你的快門殺了牠：台灣鳥類籠拍誘拍場調查實錄'
          }
        />
        <link rel="apple-touch-icon" href="%PUBLIC_URL%/favicon.ico" />
        <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans+TC&display=swap"
          rel="stylesheet"
        />
        <title>
          {data?.og_title ?? '你的快門殺了牠：台灣鳥類籠拍誘拍場調查實錄'}
        </title>
      </Helmet> */}
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <DefaultLayout>
          <Embedded />
          <Main data={data} />
        </DefaultLayout>
      </ThemeProvider>
    </>
  )
}
